import { render, staticRenderFns } from "./wf-days-or-date-display.vue?vue&type=template&id=66f5a2ab&scoped=true&"
import script from "./wf-days-or-date-display.vue?vue&type=script&lang=ts&"
export * from "./wf-days-or-date-display.vue?vue&type=script&lang=ts&"
import style0 from "./wf-days-or-date-display.vue?vue&type=style&index=0&id=66f5a2ab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f5a2ab",
  null
  
)

export default component.exports